<template>
  <GDialog v-model="propModal.status" max-width="90%">
    <div class="content-modal">
      <div class="container-close-icon" @click="closeModal()" @keydown="closeAvise()">
        <img class="close-icon" src="@/assets/icons/close.png" alt="close_modal">
      </div>
      <object :data="url" type="application/pdf" class="container-pdf-document"
        aria-labelledby="labelDocument" >
        <embed :src="url" type="application/pdf" class="container-pdf-document" />
      </object>
    </div>
  </GDialog>
</template>

<script setup>
import {
  onMounted,
  onUnmounted,
  ref,
} from 'vue';
import { sanitizeUrl } from '@braintree/sanitize-url';

const props = defineProps({
  propertieModals: Object,
});

const propModal = ref(props.propertieModals);
const url = ref('');

onMounted(() => {
  switch (propModal.value.type) {
    case 'TERMINOS_Y_CONDICIONES':
      const pdfUrl = 'https://d1mq21xo4bjiqa.cloudfront.net/documentos/aviso_privacidad_integral_mayores.pdf'
      url.value = sanitizeUrl(pdfUrl) || '';
      break;
    default:
      url.value = '';
      break;
  }
});

onUnmounted(() => {
  propModal.value = null;
});

function closeModal() {
  propModal.value.status = false;
}

</script>
<style scoped>
.content-modal {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 4px 5px rgba(0, 0, 0, 0.25);
  font-family: 'Arial', sans-serif; 
  position: relative;
}
.container-pdf-document {
  width: 100%;
  height: 500px;
  overflow: auto;
}
.container-close-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: auto;
  margin-top: -10px;
  margin-left: auto;
  min-width: 20px;
  max-width: 24px;
  width: auto;
  min-height: 20px;
  max-height: 24px;
  height: auto;
  border-radius: 10px;
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 9px;
}

.container-close-icon .close-icon {
  min-width: 20px;
  max-width: 24px;
  width: auto;
  min-height: 20px;
  max-height: 24px;
  height: auto;
  cursor: pointer;
}

.container-msg .msg-avise {
  font-size: 20px;
  text-align: justify;
  margin-left: 5px;
}

@media only screen and (min-width: 300px) and (max-width: 740px)
  and (min-height: 540px) and (max-height: 915px)
    and (orientation: portrait) {
}

@media only screen and (min-width: 650px) and (max-width: 668px)
  and (min-height: 300px) and (max-height: 380px) and (orientation: landscape) {

}

@media only screen and (min-width: 567px) and (max-width: 1025px)
  and (min-height: 300px) and (max-height: 400px)
    and (orientation: landscape) {
}

@media only screen and (min-width: 567px) and (max-width: 1025px)
  and (min-height: 300px) and (max-height: 730px)
    and (orientation: landscape) {
}
</style>